import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getGridOperators } from 'app/entities/grid-operator/grid-operator.reducer';
import { createEntity, getEntity, reset, updateEntity } from './sub-captar.reducer';

export const SubCaptarUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const gridOperators = useAppSelector(state => state.gridOperator.entities);
  const subCaptarEntity = useAppSelector(state => state.subCaptar.entity);
  const loading = useAppSelector(state => state.subCaptar.loading);
  const updating = useAppSelector(state => state.subCaptar.updating);
  const updateSuccess = useAppSelector(state => state.subCaptar.updateSuccess);

  const handleClose = () => {
    navigate('/sub-captar');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getGridOperators({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }

    const entity = {
      ...subCaptarEntity,
      ...values,
      gridOperator: gridOperators.find(it => it.id.toString() === values.gridOperator?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...subCaptarEntity,
          gridOperator: subCaptarEntity?.gridOperator?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="crawlerBackendApp.subCaptar.home.createOrEditLabel" data-cy="SubCaptarCreateUpdateHeading">
            <Translate contentKey="crawlerBackendApp.subCaptar.home.createOrEditLabel">
              Create or edit a SubCaptar
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="sub-captar-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('crawlerBackendApp.subCaptar.subCaptarCode')}
                id="sub-captar-subCaptarCode"
                name="subCaptarCode"
                data-cy="subCaptarCode"
                type="text"
              />
              <ValidatedField
                id="sub-captar-gridOperator"
                name="gridOperator"
                data-cy="gridOperator"
                label={translate('crawlerBackendApp.subCaptar.gridOperator')}
                type="select"
              >
                <option value="" key="0" />
                {gridOperators
                  ? gridOperators.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.ean}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/sub-captar"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button
                color="primary"
                id="save-entity"
                data-cy="entityCreateSaveButton"
                type="submit"
                disabled={updating}
              >
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default SubCaptarUpdate;
